import { commissionAdvanceHelp } from '@hue/contracts';
import {
  Button,
  CurrencyInput,
  DatePicker,
  HelpTip,
  Input,
  Modal,
  useSnackbar,
} from '@hue/design-system';
import { useState } from 'react';
import { commissionsApi, getApiError } from '../lib/api.js';
import { RequestAlert } from './data-view.js';

/// Registrar vale, da ficha do profissional ou da apuração (ADR 0082, decisão 24).
export function CommissionAdvanceDialog({
  resource,
  today,
  onClose,
  onSaved,
}: {
  resource: { id: string; displayName: string };
  today: string;
  onClose: () => void;
  onSaved: () => Promise<void> | void;
}) {
  const snackbar = useSnackbar();
  const [amountCents, setAmountCents] = useState<number | null>(null);
  const [paidOn, setPaidOn] = useState<string | null>(today);
  const [note, setNote] = useState('');
  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!amountCents || amountCents <= 0) return setError('Informe o valor do vale.');
    if (!paidOn) return setError('Informe o dia em que o vale saiu do caixa.');
    setSaving(true);
    try {
      await commissionsApi.createAdvance({
        resourceId: resource.id,
        amountCents,
        paidOn,
        note: note.trim() || null,
      });
      snackbar.success(`Vale registrado para ${resource.displayName}.`);
      await onSaved();
      onClose();
    } catch (cause) {
      setError(getApiError(cause));
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={`Registrar vale: ${resource.displayName}`}
      footer={
        <>
          <Button type="button" variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="button" disabled={saving} onClick={() => void save()}>
            Registrar vale
          </Button>
        </>
      }
    >
      <div className="grid gap-3">
        <p className="flex items-center gap-1 text-sm text-content-faint">
          O vale abate o que falta pagar na apuração. Não é uma despesa nova.
          <HelpTip label="Ajuda: o que é o vale" content={commissionAdvanceHelp} />
        </p>
        {error ? <RequestAlert message={error} /> : null}
        <CurrencyInput label="Valor" value={amountCents} onValueChange={setAmountCents} />
        <DatePicker label="Dia do vale" value={paidOn} onValueChange={setPaidOn} today={today} />
        <Input
          label="Observação"
          value={note}
          maxLength={500}
          onChange={(event) => setNote(event.target.value)}
        />
      </div>
    </Modal>
  );
}
